import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconLabelLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.308 19.5a1.74 1.74 0 0 1-1.277-.531 1.74 1.74 0 0 1-.531-1.277V6.308c0-.497.177-.923.531-1.277A1.74 1.74 0 0 1 4.308 4.5h10.606a1.815 1.815 0 0 1 1.446.713l4.317 5.693c.247.324.371.689.371 1.094 0 .405-.124.77-.371 1.094l-4.317 5.693a1.816 1.816 0 0 1-1.446.713H4.308Zm0-1.5h10.606a.316.316 0 0 0 .25-.116l4.317-5.692a.306.306 0 0 0 0-.384l-4.318-5.692a.316.316 0 0 0-.11-.087.33.33 0 0 0-.14-.029H4.309a.3.3 0 0 0-.221.087.3.3 0 0 0-.087.22v11.385a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconLabelLine;
